import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { cloneDeep, sortBy } from 'lodash';
import { BehaviorSubject, combineLatest, forkJoin,  Subscription, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookiesService } from '../CookieService';
import { FAVOURITES_COOKIE_EXPIRY_DAYS, FAVOURITES_COOKIE_NAME, FAVOURITES_COOKIE_SEPARATOR } from '../models/app-constants';
import { SiteDetailsModel } from '../models/SiteDetails/SiteDetailsModel';
import { SitePopupInfoModel } from '../models/SiteDetails/SitePopupInfoModel';
import { SiteWeatherForecastModel } from '../models/SiteDetails/SiteWeatherForecastModel';
import { SitesDetailsService } from '../services/sitedetails.service';
import { IteratorDirective } from '../shared/directives/iterator/iterator.directive';
import { SitesService } from '../services/sites.service';


@Component({
	selector: 'app-your-favourites',
	templateUrl: './your-favourites.component.html',
	styleUrls: ['./your-favourites.component.scss']	
})

export class YourFavouritesComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

	favourites : string[];
	favouriteSitesDetails : SiteDetailsModel[][];
	siteDetailsSubscription : Subscription;	

	private step = 3;

	constructor(private siteDetailsService : SitesDetailsService,
		private sitesService : SitesService,
		private cookieService : CookiesService)
	{

	}

	ngOnInit(): void {
		this.loadFavourites();
	}
	

	ngOnChanges(changes : SimpleChanges) {

	}

	ngAfterViewInit(): void {
		
	}

	ngOnDestroy(): void {		
		this.siteDetailsSubscription && this.siteDetailsSubscription.unsubscribe();
	}


	private loadFavourites = () => {
		console.log("Loading your favourites....");
		this.favourites = this.cookieService.getCookie(FAVOURITES_COOKIE_NAME)?.split(FAVOURITES_COOKIE_SEPARATOR).filter(Boolean) || [];
		if(0 === this.favourites.length)
		{
			this.favouriteSitesDetails = [];
			return;
		}			

		this.favouriteSitesDetails = [];
		const allRequests = this.favourites.map((favourite : string) => {
			return this.siteDetailsService.getSiteDetails(favourite);
		});		

		this.siteDetailsSubscription = combineLatest(allRequests).subscribe({
			next : (response) => {
				const results = response;
				const siteDetailsArray = sortBy(results.map((data) => {					
					//const clone = cloneDeep(data);
					const siteDetails = data; //Object.assign(new SiteDetailsModel(), clone as SiteDetailsModel)
					data.PollForecastDt && (siteDetails.PollForecastDt = new Date(Date.parse(data.PollForecastDt)));
					data.LatestResultDt && (siteDetails.LatestResultDt = new Date(Date.parse(data.LatestResultDt)));
					return siteDetails;				
				}), "SiteName");
				
				//this.favouriteSitesDetails = siteDetailsArray.filter((site) => site?.Identifier);
				this.convertTo2DimensionalArray(siteDetailsArray);
			},
			error : (ex) => {

			},
			complete : () => {
				
			}
		});
	}

	private convertTo2DimensionalArray = (sourceArray : SiteDetailsModel[]) => {
		const numIterations = Math.ceil(sourceArray.length / this.step);
		this.favouriteSitesDetails = [];
		for(let i = 0; i < numIterations; ++i)
		{
			const array = sourceArray.slice(i * this.step, i * this.step + this.step);
			this.favouriteSitesDetails.push(array);
		}
	}

	
	trackFavouriteSite = (index : number, item : SiteDetailsModel) => {		
		return item;
	}

	get favouriteSites() {
		return this.favouriteSitesDetails;
	}

	onRemoveFromFavourites = (siteIdentifier : string) => {		
		const siteDetailsArray = this.favouriteSitesDetails.flat().filter((site : SiteDetailsModel) => site.Identifier !== siteIdentifier);
		this.convertTo2DimensionalArray(siteDetailsArray);		
	}	
}
